/**
 * PageModels JS controller.
 */

import Common from './common';
import ReadMore from './read-more.js';

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class PageModels.
 */
export default class PageModels {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {
    }

    /**
     * Cache dom elements for use in the class's methods.
     *
     * @return {void}
     */
    cache() {

        // All filter checkboxes.
        this.checkboxes = $( '.filter-checkbox' );

        // All filter toggle links.
        this.filterLinks = $( '.js-toggle-filter' );

        // Parent elements.
        this.filterParents = $( '.models-search-filter' );

        // Each filter selection content inside parent element.
        if ( this.filterParents.length ) {
            this.filterContent = Common.childrenFromEach( this.filterParents, '.models-search-filter__content' );
        }

        // All filter tags.
        this.filterTags = $( '.tag--filter-selection' );

        // Sort dropdown elements.
        this.sortDropdownButton = $( '#js-toggle-sort' );
        this.sortDropdown       = $( '#js-sort-dropdown' );

        // All sorting radio inputs.
        this.sortRadios = $( '.sort-radio' );

        // Houses wrapper.
        this.postsWrapper = $( '#js-page-models-houses' );

        // Houses count number.
        this.countNumber = $( '#js-count-number' );

        // Main title and content.
        this.pageMainTitle   = $( '#js-page-models-header-title' );
        this.pageMainContent = $( '#js-page-models-header-content' );

        // Debounce effect for query requests. Waits a bit before making the query.
        this.triggerDebounce = this.debounce( this.triggerFilteredQuery.bind( this ), 1000 );

        // Load more button.
        this.loadMoreButton  = $( '#js-load-more-houses-button' );
        this.loadMoreText    = $( '#js-load-more-houses-text' );
        this.loadMoreSpinner = $( '#js-load-more-houses-spinner' );

        // Mobile search filters wrapper & toggler.
        this.mobileFiltersButton  = $( '#js-mobile-search-filters-toggle' );
        this.mobileFiltersWrapper = $( '#js-mobile-search-filters-wrapper' );

        // Title search elements.
        this.titleSearchText   = $( '#js-house-title-search-text' );
        this.titleSearchButton = $( '#js-house-title-search-button' );
        this.titleSearchTag = $( '#js-house-title-search-tag' );
        this.titleSearchTagText = $( '#js-house-title-search-tag-text' );

        // Spinner.
        this.spinner = $( '#js-page-models-houses-spinner' );

        // Malli / mallia text elements.
        this.oneResultText       = $( '#js-one-result-text' );
        this.multipleResultsText = $( '#js-multiple-results-text' );

        // Selected filters container.
        this.selectedFiltersContainer = $( '#js-selected-filter-values' );

        // Dark overlay.
        this.darkOverlay = document.getElementById( 'js-dark-overlay-models-search' );
    }

    /**
     * This functions is run after all script classes have been instantiated.
     * Use this if you need to access some other script instances before the document ready event.
     *
     * @return {void}
     */
    init() {
    }

    /**
     * All events for model search filters.
     *
     * @return {void}
     */
    events() {

        /**
         * Go through all filter parent elements.
         */
        this.filterParents.each( ( index, filterParent ) => {

            // Get count of selected filters (checkboxes).
            const selectedFiltersCount = filterParent.getElementsByClassName( 'tag--active' ).length;

            // Count number's container.
            const countContainer = filterParent.getElementsByClassName( 'selected-count' );

            // Show count if there's atleast one filter selected.
            if ( selectedFiltersCount > 0 ) {
                countContainer[0].innerHTML = ' (' + selectedFiltersCount + ')';
            }

            // Toggle links.
            const filterLink = $( filterParent ).children( '.js-toggle-filter' );

            const filterContent = $( filterParent ).children( '.models-search-filter__content' );

            // Bind a click handler to each menu parent's link.
            filterLink.on( 'click', ( e ) =>  {

                // If if already open.
                if ( filterParent.classList.contains( 'filter--open' ) ) {

                    // Remove 'filter--open' class and set correct aria-labels etc.
                    filterParent.classList.remove( 'filter--open' );
                    filterLink.attr( 'aria-expanded', false );
                    filterContent.prop( 'hidden', true );

                } else {

                    // Add 'filter--open' class and set correct aria-labels etc.
                    filterParent.classList.add( 'filter--open' );
                    filterLink.attr( 'aria-expanded', true );
                    filterContent.prop( 'hidden', false );
                }

                // Remove current-set from URL.
                this.updateCurrentSetToUrl( null );
            });
        });

        /**
         * Go through all checkboxes.
         */
        this.checkboxes.each( ( index, checkbox ) => {

            // If checkbox is clicked.
            $( checkbox ).on( 'click', ( e ) =>  {

                // Hide load more button.
                this.loadMoreButton.addClass( 'hidden' );

                // Show spinner.
                this.postsWrapper.addClass( 'loading' );
                this.spinner.addClass( 'spinner--active' );

                // Clicked checkbox's ID.
                const checkboxId = e.target.id;

                // Clicked checkbox's data-name attr.
                const checkboxName = e.target.getAttribute( 'data-name' );

                // Ancestor element.
                const targetAncestor = e.target.parentNode.parentNode.parentNode;

                // Ancestor element's data-attribute.
                const ancestorDataAttr = 'data-' + targetAncestor.getAttribute( 'data-filter-type' );

                // Checkbox's label element.
                const label = e.target.parentNode.querySelector( 'label' );

                // Count number container.
                const countContainer = targetAncestor.getElementsByClassName( 'selected-count' );

                // Get count of selected filters (checkboxes).
                let selectedFiltersCount = targetAncestor.getElementsByClassName( 'tag--active' ).length;

                // This handles post wrapper's data-attribute updates.
                this.updateWrapperDataAttributes( ancestorDataAttr, checkboxName );

                // This updates query parameters to URL.
                this.updateUrl( targetAncestor );

                // Go through all filter tags.
                this.filterTags.each( ( index, tag ) => {
                    if ( checkboxId === tag.getAttribute( 'data-id' ) ) {

                        if ( ! tag.classList.contains(
                            'filter--active' ) ) {
                            tag.classList.add( 'filter--active' );
                        } else {
                            tag.classList.remove( 'filter--active' );
                        }
                    }
                });

                // Check if label already has class 'tag--active'.
                if ( label.classList.contains( 'tag--active' ) ) {

                    // Subtract 1 from selected filters count.
                    selectedFiltersCount--;

                    // Check that there's atleast one filter selected. If not, hide count.
                    if ( selectedFiltersCount > 0 ) {
                        countContainer[0].innerHTML = ' (' + selectedFiltersCount + ')';
                    } else {
                        countContainer[0].innerHTML = '';
                    }

                    // Remove active class from checkbox's label.
                    label.classList.remove( 'tag--active' );

                } else {

                    // Add 1 to selected filters count.
                    selectedFiltersCount++;

                    // Check that there's atleast one filter selected. If not, hide count.
                    if ( selectedFiltersCount > 0 ) {
                        countContainer[0].innerHTML = ' (' + selectedFiltersCount + ')';
                    } else {
                        countContainer[0].innerHTML = '';
                    }

                    // Add active class to checkbox's label.
                    label.classList.add( 'tag--active' );
                }

                // Update selected filters container's class.
                this.countSelectedFilters();

                // Remove current-set from URL.
                this.updateCurrentSetToUrl( null );
            });

            // Trigger filtered query with debounce.
            checkbox.addEventListener( 'click', this.triggerDebounce );
        });

        /**
         * Go through all filter tags.
         */
        this.filterTags.each( ( index, tag ) => {

            // If filter tag is clicked hide it and uncheck filter checkbox.
            $( tag ).on( 'click', ( e ) =>  {

                // Hide load more button.
                this.loadMoreButton.addClass( 'hidden' );

                // Show spinner.
                this.postsWrapper.addClass( 'loading' );
                this.spinner.addClass( 'spinner--active' );

                const tagId          = tag.getAttribute( 'data-id' );
                const tagName        = tag.getAttribute( 'data-name' );
                const filterType     = tag.getAttribute( 'data-filter-type' );
                const checkbox       = document.getElementById( tagId );
                const label          = checkbox.parentNode.querySelector( 'label' );
                const targetAncestor = checkbox.parentNode.parentNode.parentNode;

                // Count number container.
                const countContainer = targetAncestor.getElementsByClassName( 'selected-count' );

                // Get count of selected filters.
                let selectedFiltersCount = targetAncestor.getElementsByClassName( 'tag--active' ).length;

                // Subtract 1 from selected filters count.
                selectedFiltersCount--;

                // Uncheck checkbox and remove active classes.
                checkbox.checked = false;
                label.classList.remove( 'tag--active' );
                tag.classList.remove( 'filter--active' );

                // Check that there's atleast one filter selected. If not, hide count.
                if ( selectedFiltersCount > 0 ) {
                    countContainer[0].innerHTML = ' (' + selectedFiltersCount + ')';
                } else {
                    countContainer[0].innerHTML = '';
                }

                // This handles post wrapper's data-attribute updates.
                this.updateWrapperDataAttributes( 'data-' + filterType, tagName );

                // This updates query parameters to URL.
                this.updateUrl( targetAncestor );

                // Update selected filters container's class.
                this.countSelectedFilters();

                // Remove current-set from URL.
                this.updateCurrentSetToUrl( null );
            });

            // Trigger filtered query with debounce.
            tag.addEventListener( 'click', this.triggerDebounce );
        });

        /**
         * Go through all sorting radio inputs.
         */
        this.sortRadios.each( ( index, radio ) => {
            $( radio ).on( 'click', ( e ) =>  {

                // Hide load more button.
                this.loadMoreButton.addClass( 'hidden' );

                // Show spinner.
                this.postsWrapper.addClass( 'loading' );
                this.spinner.addClass( 'spinner--active' );

                if ( radio.id === 'smallest' ) {

                    // Order houses by smallest area.
                    this.postsWrapper.attr( 'data-orderby', 'meta_value_num' );
                    this.postsWrapper.attr( 'data-metakey', 'house_info_area' );
                    this.postsWrapper.attr( 'data-order', 'ASC' );

                } else if ( radio.id === 'largest' ) {

                    // Order houses by largest area.
                    this.postsWrapper.attr( 'data-orderby', 'meta_value_num' );
                    this.postsWrapper.attr( 'data-metakey', 'house_info_area' );
                    this.postsWrapper.attr( 'data-order', 'DESC' );

                } else if ( radio.id === 'popular' ) {

                    // Order by views (ga popular posts).
                    this.postsWrapper.attr( 'data-metakey', '' );
                    this.postsWrapper.attr( 'data-orderby', 'post__in' );
                    this.postsWrapper.attr( 'data-order', 'DESC' );

                } else {

                    // Order by date (default).
                    this.postsWrapper.attr( 'data-metakey', '' );
                    this.postsWrapper.attr( 'data-orderby', 'date' );
                    this.postsWrapper.attr( 'data-order', 'DESC' );
                }

                this.updateRadioStateToUrl();
            });

            // Trigger filtered query with debounce.
            radio.addEventListener( 'click', this.triggerDebounce );
        });

        /**
         * Toggle sort dropdown.
         */
        this.sortDropdownButton.on( 'click', ( e ) => {

            // Open / close dropdown.
            this.sortDropdown.toggleClass( 'dropdown--open' );

            // Toggle button's dropdown--open class.
            this.sortDropdownButton.toggleClass( 'dropdown--open' );

            // Get current aria-expanded state.
            const ariaExpandedState = this.sortDropdownButton.attr( 'aria-expanded' ) === 'false';

            // Change button's aria-expanded state.
            this.sortDropdownButton.attr( 'aria-expanded', ariaExpandedState );
        });

        /**
         * Toggle mobile filters wrapper visibility.
         */
        this.mobileFiltersButton.on( 'click', ( e ) => {

            // Open / close dropdown.
            this.mobileFiltersWrapper.toggleClass( 'wrapper--open' );

            // Add wrapper--open class to button.
            if (  e.target.parentNode.classList.contains( 'wrapper--open' ) ) {
                e.target.parentNode.classList.remove( 'wrapper--open' );
                this.darkOverlay.classList.remove( 'menu--open' );

            } else {
                e.target.parentNode.classList.add( 'wrapper--open' );
                this.darkOverlay.classList.add( 'menu--open' );
            }

            // Get current aria-expanded state.
            const ariaExpandedState = e.target.parentNode.getAttribute( 'aria-expanded' ) === 'false';

            // Change button's aria-expanded state.
            e.target.parentNode.setAttribute( 'aria-expanded', ariaExpandedState );
        });

        /**
         * When title search is made.
         */
        this.titleSearchButton.on( 'click', ( e ) =>  {

            // Hide load more button.
            this.loadMoreButton.addClass( 'hidden' );

            // Show spinner.
            this.postsWrapper.addClass( 'loading' );
            this.spinner.addClass( 'spinner--active' );

            // Value from text field.
            const value = this.titleSearchText.val();

            // It there's some value.
            if ( value ) {
                this.titleSearchTagText.html( value );
                this.titleSearchTag.addClass( 'filter--active' );

                // Update post wrapper's data-attribute.
                this.postsWrapper.attr( 'data-title-search-term', value );

                // This updates query parameters to URL.
                this.updateUrl( document.getElementById( 'js-house-title-search-text' ) );
            }

            // Remove current-set from URL.
            this.updateCurrentSetToUrl( null );
        });

        // Trigger filtered query with debounce.
        this.titleSearchButton.on( 'click', this.triggerDebounce );

        // When title search filter tag is clicked.
        this.titleSearchTag.on( 'click', ( e ) =>  {

            // Hide load more button.
            this.loadMoreButton.addClass( 'hidden' );

            // Show spinner.
            this.postsWrapper.addClass( 'loading' );
            this.spinner.addClass( 'spinner--active' );

            this.titleSearchTagText.html();
            this.titleSearchTag.removeClass( 'filter--active' );

            // Update post wrapper's data-attribute.
            this.postsWrapper.attr( 'data-title-search-term', '' );

            // Empty text field.
            this.titleSearchText.val( '' );

            // Update selected filters container's class.
            this.countSelectedFilters();

            // This updates query parameters to URL.
            this.updateUrl( document.getElementById( 'js-house-title-search-text' ) );

            // Remove current-set from URL.
            this.updateCurrentSetToUrl( null );
        });

        // Trigger filtered query with debounce.
        this.titleSearchTag.on( 'click', this.triggerDebounce );

        /**
         * Click load more button.
         */
        this.loadMoreButton.on( 'click', ( e ) => this.loadMore( e ) );

        /**
         * When esc key is pressed on title search field.
         */
        this.titleSearchText.on( 'keydown', {
            thisClass: this
        }, this.titleSearchEscPressed );

        // Hide dark overlay on mobile if user clicks outside of search filters & close filters menu.
        $( document ).on( 'click', ( e ) => this.hideDarkOverlay( e ) );
    }

    /**
     * Update radio state change to URL.
     *
     * @return void
     */
    updateRadioStateToUrl() {
        let updatedUrl = this.updateQueryString( 'metakey', this.postsWrapper.attr( 'data-metakey' ), window.location.href );
        updatedUrl     = this.updateQueryString( 'order', this.postsWrapper.attr( 'data-order' ), updatedUrl );
        updatedUrl     = this.updateQueryString( 'orderby', this.postsWrapper.attr( 'data-orderby' ), updatedUrl );

        history.replaceState( '', '', updatedUrl );
    }

    /**
     * Hide dark overlay on mobile if user clicks outside of search filters & close filters menu.
     *
     * @return {void}
     */
    hideDarkOverlay( e ) {

        if ( this.darkOverlay.classList.contains( 'menu--open' ) ) {
            const target = $( e.target );

            if ( ! target.closest( '#js-mobile-models-search-nav' ).length && $( '#js-mobile-models-search-nav' ).is( ':visible' ) ) {
                this.darkOverlay.classList.remove( 'menu--open' );

                // Close dropdown.
                this.mobileFiltersWrapper.removeClass( 'wrapper--open' );

                // Remove wrapper--open class from button.
                this.mobileFiltersButton.removeClass( 'wrapper--open' );

                // Change button's aria-expanded state.
                this.mobileFiltersButton.attr( 'aria-expanded', 'false' );
            }
        }
    }

    /**
     * Update current-set value to URL.
     *
     * @param {string|null} value to add to the URL.
     * @return {void}
     */
    updateCurrentSetToUrl( value ) {

        // Remove current-set from URL.
        const updatedUrl = this.updateQueryString( 'current-set', value, window.location.href );
        history.replaceState( '', '', updatedUrl );
    }

    /**
     * When enter key is pressed on title search field.
     *
     * @param {object} e Event.
     * @return {void}
     */
    titleSearchEscPressed( e ) {

        const keypressed = e.keyCode || e.which;
        const thisClass  = e.data.thisClass;

        if ( keypressed === 13 ) {

            // Value from text field.
            const value = e.target.value;

            // It there's some value.
            if ( value ) {
                thisClass.titleSearchTagText.html( value );
                thisClass.titleSearchTag.addClass( 'filter--active' );

                // Update post wrapper's data-attribute.
                thisClass.postsWrapper.attr( 'data-title-search-term', value );

                // This updates query parameters to URL.
                thisClass.updateUrl( document.getElementById( 'js-house-title-search-text' ) );

                // Hide load more button.
                thisClass.loadMoreButton.addClass( 'hidden' );

                // Show spinner.
                thisClass.postsWrapper.addClass( 'loading' );
                thisClass.spinner.addClass( 'spinner--active' );

                // Do the query.
                thisClass.triggerFilteredQuery( thisClass );

                // Empty text field.
                thisClass.titleSearchText.val( '' );
            }
        }
    }

    /**
     * Add/remove class from selecter filters container.
     *
     * @return {void}
    */
    countSelectedFilters() {

        const count = document.querySelectorAll( '.filter--active' ).length;

        if ( count === 0 ) {
            this.selectedFiltersContainer.addClass( 'no-filters' );
        } else {
            this.selectedFiltersContainer.removeClass( 'no-filters' );
        }
    }

    /**
     * Update post wrapper's data-attributes according to selected filters.
     *
     * @param {string} attr Data attribute.
     * @param {string} term Term.
     * @return {void}
     */
    updateWrapperDataAttributes( attr, term ) {

        // Get requested data-attribute (attr) from post wrapper. e.g. data-house-style.
        const attribute = this.postsWrapper.attr( attr );

        // Create an array from data-attribute terms.
        let termArray = attribute.split( ',' );

        // Check if 'term' is already in termArray.
        if ( ! termArray.includes( term ) ) {

            // If is not in this array, add it.
            termArray.push( term );

        } else {

            // If term is in this array, remove it.
            termArray = termArray.filter( e => e !== term );
        }

        // Remove empty string elements from array.
        termArray = termArray.filter( e => e !== '' );

        // Update post wrapper's data-attributes.
        this.postsWrapper.attr( attr, termArray );
    }

    /**
     * Get query parameters from houses wrapper.
     *
     * @return {object} Query parameters.
     */
    getQueryParameters() {

        const orderby         = this.postsWrapper.attr( 'data-orderby' );
        const metakey         = this.postsWrapper.attr( 'data-metakey' );
        const order           = this.postsWrapper.attr( 'data-order' );
        const houseType       = this.postsWrapper.attr( 'data-house-type' );
        const houseFloors     = this.postsWrapper.attr( 'data-house-floors' );
        const houseBedrooms   = this.postsWrapper.attr( 'data-house-bedrooms' );
        const houseStyle      = this.postsWrapper.attr( 'data-house-style' );
        const houseRoofType   = this.postsWrapper.attr( 'data-house-roof-type' );
        const houseArea       = this.postsWrapper.attr( 'data-house-area' );
        const postsPerPage    = this.postsWrapper.attr( 'data-posts-per-page' );
        const foundPosts      = this.postsWrapper.attr( 'data-found-posts' );
        const currentSet      = this.postsWrapper.attr( 'data-current-set' );
        const titleSearchTerm = this.postsWrapper.attr( 'data-title-search-term' );
        const lang            = this.postsWrapper.attr( 'data-lang' );
        const houseModel      = this.postsWrapper.attr( 'data-house-model' );

        const queryParameters = {
            'orderby': orderby,
            'order': order,
            'metakey': metakey,
            'houseType': houseType,
            'houseFloors': houseFloors,
            'houseBedrooms': houseBedrooms,
            'houseStyle': houseStyle,
            'houseRoofType': houseRoofType,
            'houseArea': houseArea,
            'postsPerPage': postsPerPage,
            'foundPosts': foundPosts,
            'currentSet': currentSet,
            'titleSearchTerm': titleSearchTerm,
            'lang': lang,
            'houseModel': houseModel
        };

        return queryParameters;
    }

    /**
     * Update query string by key.
     *
     * @param {string} key Query parameter key.
     * @param {string} value Query parameter value.
     * @param {string} url Url to update.
     * @return {string} Modified URL.
     */
    updateQueryString( key, value, url ) {

        // If url wasn't setted use current location.
        if ( ! url ) {
            url = window.location.href;
        }

        const re = new RegExp( '([?&])' + key + '=.*?(&|#|$)(.*)', 'gi' );
        let hash;

        if ( re.test( url ) ) {

            if ( typeof value !== 'undefined' && value !== null ) {
                return url.replace( re, '$1' + key + '=' + value + '$2$3' );
            } else {
                hash = url.split( '#' );
                url = hash[0].replace( re, '$1$3' ).replace( /(&|\?)$/, '' );

                if ( typeof hash[1] !== 'undefined' && hash[1] !== null )  {
                    url += '#' + hash[1];
                }

                return url;
            }
        } else {
            if ( typeof value !== 'undefined' && value !== null ) {
                const separator = url.indexOf( '?' ) !== -1 ? '&' : '?';

                hash = url.split( '#' );
                url  = hash[0] + separator + key + '=' + value;

                if ( typeof hash[1] !== 'undefined' && hash[1] !== null ) {
                    url += '#' + hash[1];
                }

                return url;

            } else {
                return url;
            }
        }
    }

    /**
     * Trigger filttered query.
     *
     * @return {void}
     */
    triggerFilteredQuery() {

        const queryParameters = this.getQueryParameters();

        // Iterate through parameters and return false if undefined.
        for ( const key in queryParameters ) {
            if ( queryParameters.hasOwnProperty( key ) ) {
                if ( queryParameters[key] === 'undefined' || queryParameters[key] === '0' ) {
                    queryParameters[key] = false;
                }
            }
        }

        // Assign this to thisClass to pass inside success.
        const thisClass = this;

        // Do not change main content on house_model taxonomy page.
        if ( ! $( 'body' ).hasClass( 'tax-house_model' ) ) {

            // Page's main content AJAX request.
            dp( 'PageModels/MainContent', {
                tidy: true,
                data: true,
                partial: 'read-more-ajax'
            }).then( ( response ) => {

                // Show title from data.
                if ( response.data.title ) {
                    thisClass.pageMainTitle.html( response.data.title );
                }

                // Show read more content or content.
                if ( response.data.read_more ) {
                    thisClass.pageMainContent.html( response.data );
                } else {
                    thisClass.pageMainContent.html( '<div class="wysiwyg">' + response.success + '</div>' );
                }

                // Read more JS functions are not working after AJAX call without this.
                ReadMore.updateReadMoresforAjax();
            }).catch( ( error ) => {
                console.log( error );
            });
        }

        // Query AJAX request.
        dp( 'PageModels/Query', {
            tidy: true,
            data: true,
            partial: 'load-more-houses',
            args: {
                /*eslint-disable */
                ajax_params: {
                    currentSet: '1',
                    titleSearchTerm: queryParameters.titleSearchTerm,
                    order: queryParameters.order,
                    orderby: queryParameters.orderby,
                    metakey: queryParameters.metakey,
                    foundPosts: queryParameters.foundPosts,
                    houseType: queryParameters.houseType,
                    houseFloors: queryParameters.houseFloors,
                    houseBedrooms: queryParameters.houseBedrooms,
                    houseStyle: queryParameters.houseStyle,
                    houseRoofType: queryParameters.houseRoofType,
                    houseArea: queryParameters.houseArea,
                    houseModel: queryParameters.houseModel
                }
                /*eslint-enable */
            }
        }).then( ( response ) => {

            // Show load more button.
            thisClass.loadMoreButton.removeClass( 'hidden' );

            // Replace whole DOM of the wrapping element.
            thisClass.postsWrapper.html( response.success );

            // Set page to 1 for load more.
            thisClass.postsWrapper.attr( 'data-current-set', '1' );

            // Set new value to data-attribute data-found-posts.
            thisClass.postsWrapper.attr( 'data-found-posts', response.data.found_posts );

            // Show 'malli' text if only 1 result.
            if ( response.data.found_posts === '1' ) {
                thisClass.oneResultText.removeClass( 'hidden' );
                thisClass.multipleResultsText.addClass( 'hidden' );
            } else {
                thisClass.oneResultText.addClass( 'hidden' );
                thisClass.multipleResultsText.removeClass( 'hidden' );
            }

            // Hide spinner.
            thisClass.postsWrapper.removeClass( 'loading' );
            thisClass.spinner.removeClass( 'spinner--active' );

            // Set correct house count number.
            thisClass.countNumber.html( response.data.found_posts );

            // Hide load more button if there's not enough posts.
            if ( response.data.found_posts <= 10 ) {
                thisClass.loadMoreButton.addClass( 'hidden' );
            } else {
                thisClass.loadMoreButton.removeClass( 'hidden' );
            }

            // Get all favorite buttons.
            const buttons = document.querySelectorAll( '.js-favorite' );

            // Get favorite buttons again so that they work after AJAX call.
            Common.updateFavoriteButtonsList( buttons );

            // Show prices after AJAX request.
            Common.showPrices();
        }).catch( ( error ) => {
            console.log( error );
        });
    }

    /**
     * Get query parameter from URL.
     *
     * @param {string} sParam Parameter name.
     * @return {boolean|string}
     */
    getQueryParameter( sParam ) {

        const sPageURL      = decodeURIComponent( window.location.search.substring( 1 ) );
        const sURLVariables = sPageURL.split( '&' );
        let sParameterName;
        let i;

        for ( i = 0; i < sURLVariables.length; i++ ) {

            sParameterName = sURLVariables[i].split( '=' );

            if ( sParameterName[0] === sParam ) {
                return sParameterName[1] === undefined ? true : sParameterName[1];
            }
        }
    };

    /**
     * Update house type on page load to
     * Query parameters and dom.
     *
     * @param {string} filterType Filter type name.
     * @return {void}
     */
    updateFiltersOnPageLoad( filterType ) {

        let houseParameters    = this.getQueryParameter( filterType );
        const filtersContainer = $( '#js-' + filterType );
        const checkboxes       = filtersContainer.find( '.filter-checkbox' );

        if ( houseParameters ) {

            houseParameters = houseParameters.split( ',' );

            this.postsWrapper.attr( 'data-' + filterType, houseParameters );

            // Go through all checkboxes
            checkboxes.each( ( index, checkbox ) => {

                const dataName = checkbox.getAttribute( 'data-name' );
                const label    = checkbox.parentNode.querySelector( 'label' );

                if ( houseParameters.includes( dataName ) ) {
                    checkbox.checked = true;
                    label.classList.add( 'tag--active' );
                }
            });

            // Go through all filter tags.
            this.filterTags.each( ( index, tag ) => {

                const dataFilterType = tag.getAttribute( 'data-filter-type' );
                const dataName       = tag.getAttribute( 'data-name' );

                if ( houseParameters.includes( dataName ) && dataFilterType === filterType ) {
                    tag.classList.add( 'filter--active' );
                }
            });

            // Get count of selected filters (checkboxes).
            const selectedFiltersCount = filtersContainer.find( '.tag--active' ).length;

            // Count number's container.
            const countContainer = filtersContainer.find( '.selected-count' );

            // Show count if there's atleast one filter selected.
            if ( selectedFiltersCount > 0 ) {
                countContainer[0].innerHTML = ' (' + selectedFiltersCount + ')';
            }
        }

        // Update search title tag.
        if ( filterType === 'title-search-term' ) {

            const searchTerm = this.postsWrapper.attr( 'data-title-search-term' );

            // Check that there is search term present.
            if ( searchTerm ) {
                this.titleSearchTag.addClass( 'filter--active' );
                this.titleSearchTagText.text( searchTerm );
            }
        }
    }

    /**
     * Update URL according to selected filters.
     *
     * @param {string} targetAncestor ancestor's name.
     * @return {void}
     */
    updateUrl( targetAncestor ) {

        // Current URL.
        const currentUrl = window.location.href;

        // Ancestor element's data-attribute.
        const ancestorDataAttr = 'data-' + targetAncestor.getAttribute( 'data-filter-type' );

        // Atribute's value.
        let value = this.postsWrapper.attr( ancestorDataAttr );

        // Set value to null if it is an empty string.
        if ( value === '' ) {
            value = null;
        }

        const updatedUrl = this.updateQueryString( targetAncestor.getAttribute( 'data-filter-type' ), value, currentUrl );

        history.replaceState( '', '', updatedUrl );
    }

    /**
     * Debounce function to use with houses query triggering.
     *
     * @param {function} func Function to perform.
     * @param {string}   delay Delay in milliseconds.
     *
     * @return {function}
     */
    debounce( func, delay ) {

        let debounceTimer;

        return function() {
            const context = this;
            const args = arguments;
            clearTimeout( debounceTimer );

            debounceTimer = setTimeout( function() {
                func.apply( context, args );
            }, delay );
        };
    }

    /**
     * Load more houses.
     *
     * @param {object} e Event object.
     * @return {void}
     */
    loadMore( e ) {

        const queryParameters = this.getQueryParameters();

        // Variables.
        const postsPerPage = queryParameters.postsPerPage;
        const currentSet   = queryParameters.currentSet;
        const foundPosts   = queryParameters.foundPosts;

        // Iterate through parameters and return false to php if undefined.
        for ( const key in queryParameters ) {
            if ( queryParameters.hasOwnProperty( key ) ) {
                if ( queryParameters[key] === 'undefined' || queryParameters[key] === '0' ) {
                    queryParameters[key] = false;
                }
            }
        }

        // Hide load more text and show spinner.
        this.loadMoreText.addClass( 'hidden' );
        this.loadMoreSpinner.removeClass( 'hidden' );

        // Add iteration to current set keep on tracking how many clicks.
        const added = +currentSet + 1;
        const totalNumOfPosts = ( +added * +postsPerPage );

        const thisClass = this;

        // dp.js AJAX request, success, error, DOM manipulation.
        dp( 'PageModels/Query', {
            tidy: true,
            data: true,
            partial: 'load-more-houses',
            args: {
                /*eslint-disable */
                ajax_params: {
                    currentSet: added,
                    order: queryParameters.order,
                    orderby: queryParameters.orderby,
                    metakey: queryParameters.metakey,
                    titleSearchTerm: queryParameters.titleSearchTerm,
                    houseType: queryParameters.houseType,
                    houseFloors: queryParameters.houseFloors,
                    houseBedrooms: queryParameters.houseBedrooms,
                    houseStyle: queryParameters.houseStyle,
                    houseRoofType: queryParameters.houseRoofType,
                    houseArea: queryParameters.houseArea,
                    houseModel: queryParameters.houseModel
                }
                /*eslint-enable */
            }
        }).then( ( response ) => {

            // Hide spinner and show load more text.
            thisClass.loadMoreText.removeClass( 'hidden' );
            thisClass.loadMoreSpinner.addClass( 'hidden' );

            // Append posts to the wrapping element.
            thisClass.postsWrapper.append( response.success );

            // Set new value to data-attribute data-current.
            thisClass.postsWrapper.attr( 'data-current-set', added );

            // If found posts is less than total number of posts hide the load more button.
            if ( foundPosts <= totalNumOfPosts ) {
                thisClass.loadMoreButton.addClass( 'hidden' );
            }

            // Get all favorite buttons.
            const buttons = document.querySelectorAll( '.js-favorite' );

            // Get favorite buttons again so that they work after AJAX call.
            Common.updateFavoriteButtonsList( buttons );

            // Put current-set value to URL.
            this.updateCurrentSetToUrl( added );

            // Show prices after AJAX request.
            Common.showPrices();
        }).catch( ( error ) => {
            console.log( error );
        });
    }

    /**
     * Run when the document is ready.
     *
     * @return {void}
     */
    docReady() {
        this.cache();
        this.events();

        // Get filter types.
        this.filterTypes = [
            'house-type',
            'house-floors',
            'house-area',
            'house-bedrooms',
            'house-style',
            'house-roof-type',
            'title-search-term'
        ];

        // Update filters status on page load.
        this.filterTypes.forEach( ( filterType ) => this.updateFiltersOnPageLoad( filterType ) );

        // Update wrapper params.
        const currentSet = this.getQueryParameter( 'current-set' );
        const order      = this.getQueryParameter( 'order' );
        const orderby    = this.getQueryParameter( 'orderby' );
        const metakey    = this.getQueryParameter( 'metakey' );

        this.postsWrapper.attr( 'data-current-set', currentSet );
        this.postsWrapper.attr( 'data-order', order );
        this.postsWrapper.attr( 'data-orderby', orderby );
        this.postsWrapper.attr( 'data-metakey', metakey );

        // Add/remove class from selecter filters container on page load.
        this.countSelectedFilters();
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/page-models.js